import TextFieldComponent from '../../../components/TextFieldComponent';
import CheckboxComponent from '../../../components/CheckboxComponent';
import ButtonComponent from '../../../components/ButtonComponent';
import { Grid2 } from '@mui/material';
import React, { useContext, useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import zod from 'zod';
import { DeviceRecordingScheduleConfigFormSchema } from '../../../services/Devices/schemas';
import { zodResolver } from '@hookform/resolvers/zod';
import {
  useGetRecordingScheduleConfigAsync,
  useUpdateRecordingScheduleConfigAsync,
} from '../../../services/Devices/hooks/useMutation';
import { AppContext } from '../../../context/AppContextProvider';
import { NumberFieldComponent } from '../../../components/NumberFieldComponent';

interface DeviceRecordingScheduleConfigProps {
  id: number;
}

type DeviceRecordingScheduleConfigFormInput = zod.infer<
  typeof DeviceRecordingScheduleConfigFormSchema
>;

const DeviceRecordingScheduleConfig = ({
  id,
}: DeviceRecordingScheduleConfigProps) => {
  const { showSnackbar } = useContext(AppContext);
  const { control, reset, handleSubmit, watch } =
    useForm<DeviceRecordingScheduleConfigFormInput>({
      resolver: zodResolver(DeviceRecordingScheduleConfigFormSchema),
      defaultValues: {},
    });

  const {
    mutateAsync: mutateGetRecordingScheduleConfigAsync,
    isLoading: isLoadingGetRecordingScheduleConfigAsync,
  } = useGetRecordingScheduleConfigAsync();

  const {
    mutateAsync: mutateUpdateRecordingScheduleConfigAsync,
    isLoading: isLoadingUpdateRecordingScheduleConfigAsync,
  } = useUpdateRecordingScheduleConfigAsync();

  const handleSave = (data: DeviceRecordingScheduleConfigFormInput) => {
    mutateUpdateRecordingScheduleConfigAsync(
      { id, data },
      {
        onSuccess: () => {
          showSnackbar(
            'Configuração de agendamento atualizada com sucesso.',
            'success',
          );
        },
      },
    );
  };

  useEffect(() => {
    if (id) mutateGetRecordingScheduleConfigAsync(id).then(reset);
  }, [id]);

  return (
    <>
      <Grid2 container>
        <Grid2 size={12} sx={{ mt: 1 }}>
          <ButtonComponent
            fullWidth
            onClick={handleSubmit(handleSave)}
            loading={
              isLoadingGetRecordingScheduleConfigAsync ||
              isLoadingUpdateRecordingScheduleConfigAsync
            }
          >
            Salvar
          </ButtonComponent>
        </Grid2>
      </Grid2>
    </>
  );
};

export default DeviceRecordingScheduleConfig;
